import { FC, useState } from 'react';
import { Button, Icon } from 'common-components';
import { Tooltip } from '@mui/material';
import styles from './tableFilters.module.scss';
import { useTranslationContext } from '../../../contexts/translationContext';
import Search from '../../search/search';
import Toggle from '../../toggle/toggle';

const TableFilters: FC<TableFiltersProps> = (props: TableFiltersProps) => {
    const {
        onContentTypeChange,
        onSearchChange,
        onToggleChange,
        contentTypes,
        contentTypeToIconName,
        toggleDefaultValue
    } = props;

    const [selectedContentTypes, setSelectedContentTypes] = useState<string[]>([]);

    const { translate } = useTranslationContext();
    const CONTENT_TYPE = translate('ContentType');
    const SHOW_ONLY_UNTAGGED = translate('ShowOnlyUntagged');

    const onContentTypeClick = (contentType: string) => {
        if (selectedContentTypes.includes(contentType)) {
            setSelectedContentTypes(selectedContentTypes.filter(item => item !== contentType));
        } else {
            setSelectedContentTypes([...selectedContentTypes, contentType]);
        }
        onContentTypeChange(contentType);
    };

    return (
        <div className={styles.container}>
            <span className={styles.header}>{CONTENT_TYPE}</span>
            <div className={styles['content-types']}>
                {contentTypes.map((contentType: string, index: number) => {
                    return (
                        <Tooltip key={index} placement="top" title={translate(contentType)} arrow={true}>
                            <div>
                                <Button
                                    type={
                                        selectedContentTypes.includes(contentType)
                                            ? 'learningPanelAdminActionButtonIconSelected'
                                            : 'learningPanelAdminActionButtonIcon'
                                    }
                                    onClick={() => onContentTypeClick(contentType)}
                                    startIcon={
                                        <Icon
                                            name={contentTypeToIconName[contentType.toLowerCase()]}
                                            className={styles.icon}
                                        />
                                    }
                                />
                            </div>
                        </Tooltip>
                    );
                })}
            </div>
            <div>
                <Search placeholder={'Search'} onSearchChange={search => onSearchChange(search)} outerString="" />
            </div>
            <div className={styles['toggle-container']}>
                <span className={styles.header}>{SHOW_ONLY_UNTAGGED}</span>
                <Toggle
                    defaultValue={toggleDefaultValue}
                    onChange={(_event: any, checked: boolean) => onToggleChange(checked)}
                    size="small"
                />
            </div>
        </div>
    );
};

interface TableFiltersProps {
    onContentTypeChange: (contentType: string) => void;
    onSearchChange: (search: string) => void;
    onToggleChange: (value: boolean) => void;
    contentTypes: string[];
    contentTypeToIconName: { [key: string]: string };
    toggleDefaultValue: boolean;
}

export default TableFilters;
